'use strict';

var lib = require('./lib-75591456.js');
var index = require('./index-70540d0b.js');
var definitions = require('./definitions-4ae1604d.js');

var PrimaryButton = lib.variant('PrimaryButton', index.Button, {
    type: index.Type.PRIMARY,
    elevation: definitions.Elevation.LOW,
    elevationHover: definitions.Elevation.MEDIUM,
});
var OutlinedButton = lib.variant('OutlinedButton', index.Button, {
    type: index.Type.OUTLINED,
    elevation: definitions.Elevation.NONE,
});
var TonalButton = lib.variant('TonalButton', index.Button, {
    type: index.Type.TONAL,
    elevation: definitions.Elevation.NONE,
});
var TextButton = lib.variant('TextButton', index.Button, {
    type: index.Type.TEXT,
    elevation: definitions.Elevation.NONE,
});
var ToggleButton = lib.variant('ToggleButton', index.Button, {
    selectable: true,
    elevation: definitions.Elevation.NONE,
});
var MediaButton = lib.variant('MediaButton', index.Button, {
    type: index.Type.TONAL,
    selectable: true,
    onlyIcon: true,
    radius: index.Radius.ROUNDED2,
    elevation: definitions.Elevation.NONE,
});
var IconButton = lib.variant('IconButton', index.Button, {
    type: index.Type.TEXT,
    onlyIcon: true,
    elevation: definitions.Elevation.NONE,
});
var TagButton = lib.variant('TagButton', index.Button, {
    type: index.Type.TONAL,
    size: index.Size.SMALL,
    elevation: definitions.Elevation.NONE,
});

exports.IconButton = IconButton;
exports.MediaButton = MediaButton;
exports.OutlinedButton = OutlinedButton;
exports.PrimaryButton = PrimaryButton;
exports.TagButton = TagButton;
exports.TextButton = TextButton;
exports.ToggleButton = ToggleButton;
exports.TonalButton = TonalButton;
//# sourceMappingURL=variants-f3dad7e6.js.map
